/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateDiscountDto { 
    id?: number;
    name: string;
    activeFrom?: string;
    activeTo?: string;
    isActive?: boolean;
    waiveServiceFee?: boolean;
    waiveTax?: boolean;
}

